__turbopack_context__.v({
  "infoBoxDelivery": "NK5cjG_infoBoxDelivery",
  "infoBoxWrapper": "NK5cjG_infoBoxWrapper",
  "missingValueInfo": "NK5cjG_missingValueInfo",
});
